import { render, staticRenderFns } from "./00_registration.vue?vue&type=template&id=9dc8d13c"
import script from "./00_registration.vue?vue&type=script&lang=js"
export * from "./00_registration.vue?vue&type=script&lang=js"
import style0 from "./00_registration.vue?vue&type=style&index=0&id=9dc8d13c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports